import { EmbeddedCheckoutStrategy } from "@/contracts/EmbeddedCheckoutStrategy";
import IngresseEmbeddedCheckout from "@/modules/checkout/IngresseEmbeddedCheckout";
import StripeEmbeddedCheckout from "@/modules/checkout/StripeEmbeddedCheckout";
import EmbeddedCheckout, { EmbeddedCheckoutEvents } from "@/types/EmbeddedCheckout";

export default class EmbeddedCheckoutService {
  private strategy: EmbeddedCheckoutStrategy;

  constructor(provider: "Stripe" | "Ingresse") {
    const candidates = {
      Stripe: () => new StripeEmbeddedCheckout(),
      Ingresse: () => new IngresseEmbeddedCheckout(),
    };

    if (!candidates[provider]) {
      throw new Error(`Embedded checkout strategy for ${provider} not found.`);
    }

    this.strategy = candidates[provider]();
  }

  public mount(
    identifier: string,
    params: EmbeddedCheckout,
    listeners: EmbeddedCheckoutEvents,
  ): void {
    this.strategy.mount(identifier, params, listeners);
  }

  public destroy(): void {
    this.strategy.destroy();
  }
}
